import app from '../app.first';
import $ from 'jquery';
// import Recorder from './recorder';

app.AudioRecorder = class extends app.Component {
	//this function runs on every single page, so call functions from this function that you need to run on every page
	constructor($this) {
		super($this);
		$(() => this.onDocumentReady($this));
	}

	onDocumentReady($this) {
		var myRecorder = {
			data: {
				timer: 0,
				duration: '00:00:00'
			},
			objects: {
				context: null,
				stream: null,
				recorder: null
			},
			init: function () {
				if (null === myRecorder.objects.context) {
					myRecorder.objects.context = new (
						window.AudioContext || window.webkitAudioContext
					);
				}
			},
			start: function () {
				var options = { audio: true, video: false };
				navigator.mediaDevices.getUserMedia(options).then(function (stream) {
					myRecorder.objects.stream = stream;
					myRecorder.objects.recorder = new Recorder(
						myRecorder.objects.context.createMediaStreamSource(stream),
						{ numChannels: 1 }
					);
					myRecorder.objects.recorder.record();
					myRecorder.data.timer = 0
					setInterval(function () {
						myRecorder.data.timer++
						const totalMs = myRecorder.data.timer * 1000
						const duration = new Date(totalMs).toISOString().slice(11, 19)
						myRecorder.data.duration = duration
					}, 1000)

				}).catch(function (err) {
					console.log(err);
				});
			},
			stop: function (listObject, text, jobId, position) {
				if (null !== myRecorder.objects.stream) {
					myRecorder.objects.stream.getAudioTracks()[0].stop();
				}

				if (null !== myRecorder.objects.recorder) {
					myRecorder.objects.recorder.stop();

					// Validate object
					if (null !== listObject
						&& 'object' === typeof listObject
						&& listObject.length > 0) {
						// Export the WAV file
						myRecorder.objects.recorder.exportWAV(function (blob) {
							var fd = new FormData();
							fd.append('file_path', blob);
							fd.append('job_application_id', jobId);
							fd.append('text', text);
							fd.append('position', position);

							$.ajax({
								url: "/ajax/save-voice-assessment",
								data: fd,
								// dataType: 'json',
								processData: false,
								contentType: false,
								cache: false,
								method: 'POST',
								beforeSend: (xhr) => {
									xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
								},
								success: function (response) {
									if (response.success) {
										location.reload(true)
									}
								},
							});
						});
					}
				}
			}
		};

		// Prepare the record button
		$('.record-button').on('click', function () {
			var link = $(this).attr('data-link');

			// Prepare the recordings list
			var listObject = $('[data-role="' + link + '"]');
			// Initialize the recorder
			myRecorder.init();

			// Get the button state
			var buttonState = !!$(this).attr('data-recording');

			// Toggle
			if (!buttonState) {
				$(this).attr('data-recording', 'true');
				myRecorder.start();

				$(this).find('.record-start').hide();

				const recordEnd = $(this).find('.record-end')
				recordEnd.css({ 'display': 'flex', 'align-items': 'center' })

				setInterval(function () {
					$(recordEnd).find('.duration').html(myRecorder.data.duration)
				}, 100)
			} else {
				var text = $(this).attr('data-text');
				var jobId = $(this).attr('data-job-id');
				var position = $(this).attr('data-position');

				$(this).attr('data-recording', '');
				myRecorder.stop(listObject, text, jobId, position);

				$(this).find('.record-end').hide();

				$(this).find('.spinner').show();
			}
		});

		$('.recorder-container').on('click', function () {
			var key = $(this).attr('data-key');

			$('#audio_path_' + key).click();
		});

		$('.audio-path').on("change", function() {
			// var fileName = $(this).val().split("\\").pop(); // Get the filename
			// alert("Selected file: " + fileName);
			$('#audio_form_' + $(this).attr('data-key')).submit();

			$('#audio_form_' + $(this).attr('data-key')).find('.spinner').show();
		});
	}

}
